import React from "react";
import { Link } from "react-router-dom";
import logo from "/Logo_dashboard.webp";

const Header = () => {
  return (
    <header className="header pb-2">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <div className="logo-icon">
                <img
                  src={logo}
                  alt="PolicySaath Logo"
                  width="146"
                  height="70"
                  style={{ height: "70px", width: "auto" }}
                />
              </div>
            </Link>
          </div>
          <nav className="navigation">
            <ul className="nav-links">
              <li>
                <Link to="/" className="nav-link active">Home</Link>
              </li>
              <li>
                <Link to="/about-us" className="nav-link">About Us</Link>
              </li>
              <li>
                <Link to="/contact-us" className="nav-link">Contact Us</Link>
              </li>
              <li>
                <Link to="/subscription" className="nav-link">Subscription</Link>
              </li>
            </ul>
          </nav>
          <div className="header-buttons">
            <Link to="/login" className="btn-login">Login</Link>
            <Link to="/register" className="btn-register">Register</Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;